import dayjs from 'dayjs';
import { UnitType } from 'app/shared/model/enumerations/unit-type.model';

export interface IProductSpecification {
  id?: number;
  name?: string | null;
  description?: string | null;
  unit?: keyof typeof UnitType | null;
  validFrom?: dayjs.Dayjs | null;
  validTo?: dayjs.Dayjs | null;
}

export const defaultValue: Readonly<IProductSpecification> = {};
